"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Table3D = void 0;
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const useCallforward_1 = __importDefault(require("@opsbase/react-hooks/useCallforward"));
const web_css_1 = __importStar(require("@opsbase/web-css"));
const color_1 = __importDefault(require("color"));
const react_1 = __importDefault(require("react"));
const makeMyClasses = () => ({
    table: {
        marginTop: 15,
        width: '100%',
        fontSize: 12,
        borderCollapse: 'collapse',
    },
    row: {
        height: 40,
    },
    topHeading: {
        padding: 4,
        textAlign: 'center',
        borderBottom: '1px solid ' + lib_palette_1.default.LavendarGrey.main,
        color: lib_palette_1.default.BlackCoral.main,
    },
    sideHeading: {
        width: '100%',
        padding: 4,
        textAlign: 'left',
        borderRight: '4px solid ' + lib_palette_1.default.LavendarGrey.main,
        borderBottom: '1px solid ' + lib_palette_1.default.LavendarGrey.main,
        color: lib_palette_1.default.BlackCoral.main,
    },
    dataCell: {
        cursor: 'pointer',
        textAlign: 'center',
        padding: 4,
        minWidth: 50,
        borderBottom: '1px solid ' + lib_palette_1.default.LavendarGrey.main,
        '&:hover': {
            textDecoration: 'underline',
        },
    },
    dataCellEmpty: {
        color: lib_palette_1.default.LavendarGrey.main,
    },
});
function Table3D(props) {
    var _a;
    const { data, conditionalFormating, onClickDatum, ySuffix } = props;
    const myCss = (0, web_css_1.default)(makeMyClasses);
    const handleClick = (0, useCallforward_1.default)(datum => e => {
        onClickDatum === null || onClickDatum === void 0 ? void 0 : onClickDatum(e, { datum });
    }, [onClickDatum]);
    if (!((_a = data === null || data === void 0 ? void 0 : data[0]) === null || _a === void 0 ? void 0 : _a.length))
        return null;
    return (react_1.default.createElement("table", { className: myCss.table },
        react_1.default.createElement("thead", null,
            react_1.default.createElement("tr", { className: myCss.row },
                react_1.default.createElement("th", { className: myCss.topHeading }),
                data[0].map(d => (react_1.default.createElement("th", { key: d.xDim.id, className: myCss.topHeading }, d.xDim.label.split('\n').map((v, idx) => (react_1.default.createElement("div", { key: idx }, v)))))))),
        react_1.default.createElement("tbody", null, data.map(dd => (react_1.default.createElement("tr", { key: dd[0].yDim.id, className: myCss.row },
            react_1.default.createElement("th", { className: myCss.sideHeading, style: { borderRightColor: dd[0].color1 } }, dd[0].yDim.label),
            dd.map(d => (react_1.default.createElement("td", { key: d.yDim.id + '.' + d.xDim.id, className: (0, web_css_1.cx)(!d.y ? myCss.dataCellEmpty : undefined, myCss.dataCell), style: getCellStyle(d.y, conditionalFormating), onClick: handleClick(d) }, d.y + '' + ySuffix)))))))));
}
exports.Table3D = Table3D;
exports.default = Table3D;
function getCellStyle(value, conditionalFormatting) {
    if (!conditionalFormatting || !value)
        return undefined;
    const { bad, good } = conditionalFormatting;
    const goodness = bad > good ? bad - value : value;
    const r = (0, color_1.default)(lib_palette_1.default.error.main);
    const a = (0, color_1.default)(lib_palette_1.default.warning.main);
    const g = (0, color_1.default)(lib_palette_1.default.positive.main);
    const color = goodness <= 50 ? r.mix(a, goodness / 50) : a.mix(g, (goodness - 50) / 50);
    return {
        color,
    };
}
